import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { asyncReceiveCover } from '../../../store/plain/coverbg/action';
import { DirectAuthor } from '../../pieces/DirectAuthor';
import DirectAvatar from '../../pieces/DirectAvatar';

export function ProfileHeader({ ava, id, name, email, score = 0 }) {
  const dispatch = useDispatch();
  const { coverbg = null } = useSelector((state) => state);
  useEffect(() => {
    if (coverbg === null) dispatch(asyncReceiveCover());
  }, [coverbg, dispatch]);

  return (
    <div
      style={coverbg && { backgroundImage: `url(${coverbg})` }}
      className="flex h-full w-full items-center gap-6 rounded-t-2xl from-sky-500 to-indigo-500 p-4 pt-10 text-white dark:from-purple-500 dark:to-pink-500"
    >
      <div className="grid h-16 w-16 place-items-center overflow-hidden rounded-full bg-blue-500 shadow-inner">
        <DirectAvatar source={ava} altcap={name} />
      </div>
      <div className="flex flex-col">
        <div className="text-clip text-xl font-bold drop-shadow-md line-clamp-1">
          <DirectAuthor id={id} name={name} />
        </div>
        <div className="inline-flex items-center gap-1 text-sm opacity-90">
          <div className="text-clip drop-shadow line-clamp-1">{email}</div>
          <div>
            <Icon icon="ci:dot-03-m" />
          </div>
          <div className="text-clip drop-shadow line-clamp-1 max-[319px]:hidden">
            <div className="text-clip line-clamp-1">{score} exp</div>
          </div>
        </div>
      </div>
    </div>
  );
}

ProfileHeader.propTypes = {
  ava: PropTypes.string.isRequired,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  score: PropTypes.number,
};
